import { lazyLoad } from 'utils/loadable';

export const DealerInventoryFeedSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.DealerInventoryFeedSettingsComponent,
);
